/**
 * This is currently published MLflow version that should be available in PyPi
 * TODO(ML-33049): Implement a mechanism to bump this version automatically when MLflow is released.
 */
export const MLFLOW_PUBLISHED_VERSION = /* BEGIN-MLFLOW-VERSION */ '2.4.2'; /* END-MLFLOW-VERSION */
